import { createSpinner, showSpinner } from '@syncfusion/ej2-popups';
import * as React from 'react';
import { useEffect } from "react";
import { AppBarComponent } from '@syncfusion/ej2-react-navigations';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

function Loading() {

    useEffect(() => {
    
        createSpinner({
            target: document.getElementById('container')!,
        });
        
        showSpinner(document.getElementById('container')!);

     });

    return (
        <React.Fragment>
            <div className="row" style={{ maxHeight: '40px' }}>
                <div className="col-md-12">
                    <AppBarComponent mode="Dense" colorMode="Primary">
                        <ButtonComponent 
                            ref={(denseBtn: any) => (denseBtn = denseBtn)} 
                            aria-label='menu' 
                            cssClass='e-inherit menu' 
                            iconCss='e-icons e-menu'
                        ></ButtonComponent>
                        <span className="dense">Contentum document editor</span>
                        <div className="e-appbar-spacer"></div>
                    </AppBarComponent>
                </div>
            </div>
            <div className="control-pane">
                <div id="container" className="control-section col-lg-12 spinner-target"></div>
            </div>
        </React.Fragment>
    );
}
export default Loading;